import fetch from "unfetch";
import VueCookies from "vue-cookie";

const BASE_URL = window.location.hostname === 'localhost' ? import.meta.env.VITE_API_URL : `${window.location.protocol}//${window.location.hostname}`;

export default class GraphQL {
    query(url, obj, requestMethod = 'POST') {
        return new Promise((resolve, reject) => {
            let headers =  { 
                "Content-Type": "application/json"
            };

            if (this.getCustomerCookieToken()) {
                headers["Authorization"] = "Bearer " + this.getCustomerCookieToken();
            }
            
            resolve(fetch(url, {
                method: requestMethod,
                headers: headers,
                body: JSON.stringify(obj)
            })
                .then(res => { 
                    return res.json()
                })
                .then(res => {
                    if (!res.error) {
                        return res;
                    } else {
                        throw new Error(res.error);
                    }
                }));
        });
    }

    getMinesGame() {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/api/game/mines/current', {}, 'GET')
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    getCustomerCookieToken() {
        return VueCookies.get("token");
    }

    getCreateUserVK() {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/graphql', {
                query: `mutation CreateUser {
                        CreateUserVK {
                            url
                        }
                    }`
            })
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    getLoginUser(obj) {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/api/auth/login', {
                'username': obj.username,
                'password': obj.password,
                'recaptcha': obj.recaptcha
            })
            .then(data => {
                resolve(data)
            })
            .catch(error => reject(error));
        });
    }

    getUser() {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/api/user', '', 'GET')
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    getResetPassword(obj) {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/graphql/user', {
                query: `mutation($old_password: String!, $new_password: String!) {
                            ResetPassword(old_password: $old_password, new_password: $new_password) {
                                success
                              }
                    }`,
                variables: obj
            })
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    getLinkUserVK() {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/graphql/user', {
                query: `mutation {
                        LinkUserVK {
                            url
                        }
                    }`
            })
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    getGameHashGuest() {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/graphql', {
                query: `mutation {
                        GetHashGuest {
                            hash
                            hid
                        }
                    }`
            })
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    getGameHash() {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/graphql/game', {
                query: `mutation {
                        GetHash {
                            hash
                            hid
                        }
                    }`
            })
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    getGameHistory(obj) {
        return new Promise((resolve, reject) => {
            this.query(BASE_URL + '/api/game/history', {
                'id': obj.id,
                'game': obj.game,            
            }, 'POST')
            .then(data => resolve(data))
            .catch(error => reject(error));
        });
    }

    axiosGetError(error) {
        if(error.response) {
            if(error.response.data.error) {
                return error.response.data.error;
            }
        }

        return "Возникла непредвиденная ошибка, попробуйте повторить попытку позже";
    }

    getError(error) {
        error = error.toString();
        error = error.replace(/Error: /g, '');
        // error = JSON.parse(error);
        // error = error[0];

        return error;
    }
}
